import FooterCsr from "@v2/components/footer/index.csr";

interface ExampleLCSettingsType { }
interface ExampleLCDataType { }

export default function FooterLC({ content }: {
    content: {
        data: ExampleLCDataType,
        settings: ExampleLCSettingsType
    };
}) {
    return <FooterCsr />
}